import React, { useEffect, useState } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { MenuIcon, XIcon } from 'lucide-react';
const navLinks = [{
  label: 'How it works',
  hash: '#how-it-works'
}, {
  label: 'Features',
  hash: '#features'
}, {
  label: 'Privacy',
  hash: '#privacy'
}, {
  label: 'Use cases',
  hash: '#use-cases'
}, {
  label: 'FAQ',
  hash: '#faq'
}];
export function RecallLogo({
  size = 'md'
}: {
  size?: 'sm' | 'md';
}) {
  const box = size === 'md' ? 'h-9 w-9' : 'h-8 w-8';
  return <img src="https://cdn.magicpatterns.com/uploads/2Prbqgfyj1rGe5WbKHUdVy/image.png" alt="Recall logo" className={`${box} rounded-lg`} data-id="element-174" />;
}
function SessionTimecode() {
  const [seconds, setSeconds] = useState(0);
  useEffect(() => {
    const id = setInterval(() => setSeconds(s => s + 1), 1000);
    return () => clearInterval(id);
  }, []);
  const h = String(Math.floor(seconds / 3600)).padStart(2, '0');
  const m = String(Math.floor(seconds % 3600 / 60)).padStart(2, '0');
  const s = String(seconds % 60).padStart(2, '0');
  return <span className="font-mono-brand hidden xl:inline-flex items-center gap-1.5 text-[11px] tracking-wider text-slate-400" title="Session timer — capture is off" aria-hidden="true" data-id="element-175">
      <span className="h-1.5 w-1.5 rounded-full border border-teal-600/60" data-id="element-176" />
      standby{' '}
      <span className="tabular-nums text-slate-500" data-id="element-177">
        {h}:{m}:{s}
      </span>
    </span>;
}
export function Header() {
  const [scrolled, setScrolled] = useState(false);
  const [mobileOpen, setMobileOpen] = useState(false);
  const {
    pathname
  } = useLocation();
  const onHome = pathname === '/';
  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 8);
    window.addEventListener('scroll', onScroll, {
      passive: true
    });
    return () => window.removeEventListener('scroll', onScroll);
  }, []);
  return <header className={`fixed top-0 inset-x-0 z-50 bg-white/90 backdrop-blur-md transition-colors ${scrolled ? 'border-b border-slate-200' : 'border-b border-slate-100'}`} data-id="element-178">
      <nav className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8 h-16 flex items-center justify-between" aria-label="Main navigation" data-id="element-179">
        <Link to="/" className="flex items-center gap-2.5" aria-label="Recall home" data-id="element-180">
          <RecallLogo data-id="element-181" />
          <span className="leading-tight" data-id="element-182">
            <span className="font-display block text-base font-bold text-ink tracking-tight" data-id="element-183">
              Recall
            </span>
            <span className="font-mono-brand block text-[10px] text-slate-500 -mt-0.5" data-id="element-184">
              borrower_intelligence
            </span>
          </span>
        </Link>

        <ul className="hidden lg:flex items-center gap-8" data-id="element-185">
          {navLinks.map(link => <li key={link.hash} data-id="element-186">
              <a href={onHome ? link.hash : `/${link.hash}`} className="text-sm font-medium text-slate-600 hover:text-slate-900 transition-colors" data-id="element-187">
                {link.label}
              </a>
            </li>)}
          <li data-id="element-188">
            <Link to="/pricing" className={`text-sm font-medium transition-colors ${pathname === '/pricing' ? 'text-teal-600' : 'text-slate-600 hover:text-slate-900'}`} data-id="element-189">
              Pricing
            </Link>
          </li>
        </ul>

        <div className="hidden lg:flex items-center gap-4" data-id="element-190">
          <SessionTimecode data-id="element-191" />
          <a href="https://github.com/Nimbus-Cloud-Solutions/recall-ai-install/releases/latest/download/Recall-Setup.exe" className="inline-flex items-center gap-2 rounded-lg bg-teal-600 px-4 py-2.5 text-sm font-bold text-white hover:bg-teal-700 transition-colors" data-id="element-192">
            Download for Windows
          </a>
        </div>

        <button type="button" className="lg:hidden inline-flex items-center justify-center rounded-md p-2 text-slate-600 hover:bg-slate-100" aria-expanded={mobileOpen} aria-label="Toggle navigation menu" onClick={() => setMobileOpen(o => !o)} data-id="element-193">
          {mobileOpen ? <XIcon className="h-6 w-6" aria-hidden="true" data-id="element-194" /> : <MenuIcon className="h-6 w-6" aria-hidden="true" data-id="element-195" />}
        </button>
      </nav>

      {mobileOpen && <div className="lg:hidden border-t border-slate-200 bg-white px-4 pb-4 pt-2" data-id="element-196">
          <ul className="space-y-1" data-id="element-197">
            {navLinks.map(link => <li key={link.hash} data-id="element-198">
                <a href={onHome ? link.hash : `/${link.hash}`} onClick={() => setMobileOpen(false)} className="block rounded-md px-3 py-2 text-sm font-medium text-slate-600 hover:bg-slate-50 hover:text-slate-900" data-id="element-199">
                  {link.label}
                </a>
              </li>)}
            <li data-id="element-200">
              <Link to="/pricing" onClick={() => setMobileOpen(false)} className="block rounded-md px-3 py-2 text-sm font-medium text-slate-600 hover:bg-slate-50 hover:text-slate-900" data-id="element-201">
                Pricing
              </Link>
            </li>
          </ul>
          <a href="https://github.com/Nimbus-Cloud-Solutions/recall-ai-install/releases/latest/download/Recall-Setup.exe" onClick={() => setMobileOpen(false)} className="mt-3 flex items-center justify-center gap-2 rounded-lg bg-teal-600 px-4 py-2.5 text-sm font-bold text-white" data-id="element-202">
            Download for Windows
          </a>
        </div>}
    </header>;
}